module.exports = __webpack_public_path__ + "img/bottom.66905131.png";